(() => {
  const protectedImage = (target) =>
    target instanceof Element && Boolean(target.closest('main img'));

  document.addEventListener('contextmenu', (event) => {
    if (protectedImage(event.target)) event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    if (protectedImage(event.target)) event.preventDefault();
  });

  const lockImages = () => {
    document.querySelectorAll('main img').forEach((image) => {
      image.draggable = false;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockImages, { once: true });
  } else {
    lockImages();
  }
})();
